// extracted by mini-css-extract-plugin
export var brand = "_4w-9";
export var compact = "_4w-6";
export var extraSmall = "_4w-7";
export var icon = "_4w-0";
export var large = "_4w-4";
export var light = "_4w-1";
export var medium = "_4w-5";
export var outline = "_4w-b";
export var primaryDark = "_4w-a";
export var primaryLight = "_4w-8";
export var primaryModern = "_4w-c";
export var success = "_4w-2";
export var successSolid = "_4w-3";